import { render, staticRenderFns } from "./ImportPoint.vue?vue&type=template&id=7d47b77e"
import script from "./ImportPoint.vue?vue&type=script&lang=js"
export * from "./ImportPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports